<template>
    <div class="cabinet-content-wrap">
        <div v-if="this.errors.getProduct">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryLoadingProduct"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
        <div
            v-if="Object.keys(getFormattedProduct).length"
            class="cabinet-product-card cabinet-product-card--supplier d-flex flex-column flex-lg-row"
        >
            <router-link
                :to="{ name: 'SupplierProducts' }"
                class="cabinet-product-back cabinet-btn--back"
            ></router-link>
            <section
                class="cabinet-product-detail d-flex flex-column flex-md-row justify-content-md-between w-100"
            >
                <div class="cabinet-product-left">
                    <image-swiper :images="getFormattedProduct.images" />

                    <div class="d-md-none pt-4">
                        <detail-head btn-class="cabinet-product-detail__btn" />
                    </div>
                    <!-- /d-md-none -->

                    <garniture
                        v-if="getFormattedProduct.garniture"
                        :product="getFormattedProduct"
                        :set="set"
                    />
                </div>

                <div class="cabinet-product-right">
                    <div class="d-none d-md-block">
                        <detail-head />
                    </div>

                    <tabs />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import ImageSwiper from '@/components/Cabinet/Supplier/Product/Detail//DetailSwiper.vue'
import DetailHead from '@/components/Cabinet/Supplier/Product/Detail/DetailHead.vue'
import Garniture from '@/components/Cabinet/Supplier/Product/Detail/DetailGarniture.vue'
import Tabs from '@/components/Cabinet/Supplier/Product/Detail/DetailTabs.vue'

export default {
    name: 'SupplierProductsDetail',
    components: {
        ImageSwiper,
        DetailHead,
        Garniture,
        Tabs
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('supplierSet', ['set']),
        ...mapState('supplierProducts', ['errors']),
        ...mapGetters('supplierProducts', ['getFormattedProduct'])
    },
    async mounted() {
        this.tryLoadingProduct()
    },
    methods: {
        ...mapActions('supplierProducts', ['getProduct']),
        ...mapActions('supplierSet', ['getSet']),
        async tryLoadingProduct() {
            await this.getProduct(this.$route.params.id)

            if (this.getFormattedProduct.garniture) {
                await this.getSet({
                    id: this.getFormattedProduct.garniture.set_id
                })
            }
        }
    }
}
</script>
